import { tokens, SvgIcon, SvgNames } from "@sunrun/experience-ui-components";
import styled from "@emotion/styled/macro";

type TaskCheckMarkProps = {
  size?: number;
  locked?: boolean;
  checked?: boolean;
  halfChecked?: boolean;
  hasWarning?: boolean;
};

const WarningBadge = styled.div`
  position: absolute;
  top: -3px;
  left: -3px;
  display: flex;
  line-height: 0;
  z-index: 1;
`;

const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

const TaskCheckMark = ({
  size = tokens.FONT_SIZE_4,
  checked = false,
  halfChecked = false,
  locked = false,
  hasWarning = false,
}: TaskCheckMarkProps) => {
  const renderIcon = () => {
    if (checked) {
      return (
        <SvgIcon
          name={SvgNames.CheckFilled}
          height={size}
          width={size}
          color={tokens.SUCCESS_60}
          data-testid="checked"
        />
      );
    }

    if (locked) {
      return (
        <SvgIcon
          name={SvgNames.LockFilled}
          height={size}
          width={size}
          color={tokens.TINTS_HERO_BLUE_70}
          data-testid="locked"
        />
      );
    }

    if (halfChecked) {
      return (
        <SvgIcon
          name={SvgNames.InProcess}
          height={size}
          width={size}
          color={tokens.SUCCESS_60}
          data-testid="half-checked"
        />
      );
    }

    return (
      <SvgIcon
        name={SvgNames.ToDo}
        height={size}
        width={size}
        color={tokens.TINTS_HERO_BLUE_70}
        data-testid="unchecked"
      />
    );
  };

  if (hasWarning) {
    const badgeSize = Math.round(Number(size) * 0.5);
    return (
      <Wrapper>
        {renderIcon()}
        <WarningBadge data-testid="warning-badge">
          <SvgIcon
            name={SvgNames.WarningFilled}
            height={badgeSize}
            width={badgeSize}
            color={tokens.WARNING_20}
          />
        </WarningBadge>
      </Wrapper>
    );
  }

  return renderIcon();
};

export { TaskCheckMark };
export type { TaskCheckMarkProps };
